import React from 'react';

import { BaseOption } from 'components/Form/Inputs/Select/Select';
import { ArrowIcon } from 'components/Icons';
import { TableSortDirection } from 'components/Lists/TableTypes';
import { FilterByConfig } from 'components/TableFilterControls/TableFilterControls';

import { getSortValue } from './helpers';

const RightArrow = (
  <ArrowIcon
    className="ml-1 mr-1"
    direction={ArrowIcon.DIRECTIONS.RIGHT}
    size={12}
    color="currentColor"
  />
);

interface MobileSortOption extends BaseOption {
  id: string;
  direction: TableSortDirection;
  value: string;
}

export const MOBILE_SORT_OPTIONS: MobileSortOption[] = (
  [
    {
      id: 'dateInvited',
      label: 'Date Invited',
      direction: 'DESC'
    },
    {
      id: 'artistName',
      label: <>A {RightArrow} Z</>,
      direction: 'ASC'
    },
    {
      id: 'artistName',
      label: <>Z {RightArrow} A</>,
      direction: 'DESC'
    },
    {
      id: 'artistPopularity',
      label: 'Popularity',
      testId: 'LabelSubscribers-sort-artistPopularity',
      direction: 'DESC'
    },
    {
      id: 'averageRating',
      label: 'Avg. Rating',
      direction: 'DESC'
    },
    {
      id: 'lastReactedAt',
      label: 'Latest Reaction',
      direction: 'DESC'
    }
  ] as const
).map(option => ({
  ...option,
  value: getSortValue(option.id, option.direction)
}));

export const DEFAULT_SORT = MOBILE_SORT_OPTIONS[0];

export type FilterSlug =
  | 'all'
  | 'artists-roster'
  | 'accepted'
  | 'unaccepted'
  | 'archive-access'
  | 'recently-reacted';

export interface SubscriberFilterOption {
  label: string;
  value: FilterSlug;
  filterBy: FilterByConfig;
  testId?: string;
}

export const SUBSCRIBER_FILTER_OPTIONS: SubscriberFilterOption[] = [
  {
    label: 'All Subscribers',
    value: 'all',
    filterBy: {}
  },
  {
    label: 'Artists on Roster',
    value: 'artists-roster',
    filterBy: { isRoster: { is: true } }
  },
  {
    label: 'Accepted Invites',
    value: 'accepted',
    testId: 'LabelSubscribers-filter-accepted',
    filterBy: { isFollowing: { is: true } }
  },
  {
    label: 'Unaccepted Invites',
    value: 'unaccepted',
    filterBy: { isFollowing: { is: false } }
  },
  {
    label: 'Archive Access',
    value: 'archive-access',
    filterBy: { archiveAccess: { is: true } }
  },
  {
    label: 'Recently Reacted',
    value: 'recently-reacted',
    filterBy: { recentlyReacted: { is: true } }
  }
];

export const DEFAULT_FILTER = SUBSCRIBER_FILTER_OPTIONS[0];
